// Kanonische Liste der Modul-Schlüssel (AUFTRAG §8). Besitzer: geruest.
export const MODULE_KEYS = [
  'home',
  'people',
  'profil',
  'framework',
  'scorecard',
  'zyklen',
  'kalibrierung',
  'goals',
  'befoerderung',
  'pip',
  'bonus',
  'verguetung',
  'vertraege',
  'insights',
  'konten',
  'chat',
  'admin',
  'techhub',
  'assistent',
  'wissen',
  'quellen',
  'connect',
  'extension',
  'macapp',
  'ki',
] as const;

export type ModuleKey = (typeof MODULE_KEYS)[number];

export function isModuleKey(value: string): value is ModuleKey {
  return (MODULE_KEYS as readonly string[]).includes(value);
}
